import styled from 'styled-components';

const BlogItemStyle = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;

    padding-bottom: 100px;
	overflow: hidden;
    
    .section {
        width: 100%;
        padding: 0 32px;
    }
    
    .blog {
        &-link {
            width: 100%;
            max-width: 326px;
            cursor: pointer;
        }

        &-header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
        
        &-hello {
            background: white;
            border-radius: 33px;
            width: 100%;
            padding: 21px 33px;
            display: flex;
            justify-content: center;

            &-content {
                justify-content: space-between;
                align-items: center;
                display: flex;
                width: 100%;
                max-width: 1026px;
            }
            
            &-image {
                padding: 0;
                margin-right: -53px;
            }
        }
        &-previws {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
            justify-content: flex-start;
            margin: 40px auto 0;
        }
        &-block {
            max-width: 743px;
            &-text {
                margin-top: 25px;
                & > div {
                    gap: 20px;
                    display: flex;
                    flex-direction: column;
                }
                
                ul {
                    gap: 10px;
                    display: flex;
                    flex-direction: column;
                }
                
                li {
                    margin-left: 20px;
                    list-style-type: disc;
                    
                    font-size: 14px;
                }
                
                a {
                    color: #024896;
                }
            }
            &-list {
                margin-top: 20px;
                margin-left: 16px;
                li {
                    margin-top: 22px;
                }
            }
            &-image {
                margin-top: 40px;
            }
            &-title {
                margin-top: 40px;
            }
        }
        &-image {
            margin-top: 29px;
            padding: 0;
            margin-bottom: 39px;
        }
    }
    
    .article-title {
        margin-top: 48px;
        display: flex;
        gap: 4px;
        color: #838383;
        white-space: nowrap;
        &-link {
            
            transition: 0.35s;
            &:hover {
                color: #000000;
                transition: 0.35s;
            }
        }
    }

    .blog-title {
        margin-top: 24px;
    }
    
    .sub-title {
        margin-top: 15px;
    }
    
    .main-gray {
        color: #838383;
    }
    
    .text-gray {
        color: #515151;
    }
    
    .divider {
        width: 100%;
        height: 8px;
        background: #3A3A3A;
        margin: 66px 0 40px;
    }
    
    .response {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 60px;
    }
    
    .response-button {
        display: flex;
        button {
            padding: 15px 20px;
        }
        &-icon {
            padding: 0;
        }
        &-group {
            display: flex;
            gap: 8px;
            align-items: center;
        }
        &-active {
            background-color: #B0C9C0!important;
            button {
                p {
                    color: #fff!important;
                }
            }
        }
    }
    .related {
        display: flex;
        gap: 26px;
        margin-top: 29px;
        flex-wrap: wrap;
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
        padding-bottom: 90px;

        .article-title {
            margin-top: 18px;
        }

        .blog-title {
            margin-top: 14px;
        }

        .sub-title {
            margin-top: 5px;
        }
        
        .blog-image {
            margin-top: 19px;
            height: 200px!important;
        }

        .blog-block {
            margin-top: 29px;
            padding: 0 16px;
            width: 100%;
        }

        .blog-block-image {
            margin-top: 30px;
        }
        
        .divider {
            margin: 56px 0 30px;
        }
        
        .response {
            margin-bottom: 50px;
            flex-direction: column;
        }
        
        .blog-block-title {
            margin-top: 30px;
        }
        
        .blog-block-text {
            margin-top: 15px;
        }
        
        .blog-block-list li {
            margin-top: 12px;
        }

        
        .related {
            flex-direction: column;
            margin-top: 19px;
            gap: 16px;
            align-items: center;
        }
        .blog-block-image {
            width: 100%!important;
        }
    }
`;

export default BlogItemStyle;
